<template>
  <page :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap align-end>
        <v-flex xs9>
          <card-menu :items="cardMenu" @cardReturn="visibleControl" subMenu></card-menu>
        </v-flex>
        <v-flex xs3>
          <v-container fluid class="pa-0" align="right">
            <span align="right">
              <div class="text-center">
                <v-tooltip top v-if="checkAccess([permissionKeys.perm_011025])">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="primary" v-on="on" @click.native="doButtons('amend')"
                      ><v-icon dark>mdi-pencil-box-outline</v-icon></v-btn
                    >
                  </template>
                  <span>Amend RI</span>
                </v-tooltip>
              </div>
            </span>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    Filters for {{ listMode }}
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg4 xs6>
                          <v-autocomplete
                            :items="mainClsList"
                            v-model="filters.polType"
                            :label="filtersLabel.polType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="polType"
                            :data-vv-as="filtersLabel.polType"
                            :error-messages="errors.collect('polType')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex lg8></v-flex>
                        <v-flex lg4 xs6>
                          <v-text-field
                            v-model="filters.polNo"
                            :label="filtersLabel.polNo"
                            :error-messages="errors.collect('polNo')"
                            data-vv-name="polNo"
                            :data-vv-as="filtersLabel.polNo"
                            v-validate="'entry|max:16'"
                            :maxlength="16"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6 v-if="this.filters.review === 'amend'">
                          <v-text-field
                            v-uppercase="filters.mstPolOpenCvr"
                            v-model="filters.mstPolOpenCvr"
                            :label="filtersLabel.mstPolOpenCvr"
                            :error-messages="errors.collect('mstPolOpenCvr')"
                            data-vv-name="mstPolOpenCvr"
                            :data-vv-as="filtersLabel.mstPolOpenCvr"
                            v-validate="'entry|max:16'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6 v-else>
                          <v-text-field
                            v-model="filters.riCo"
                            :label="filtersLabel.riCo"
                            :error-messages="errors.collect('riCo')"
                            data-vv-name="riCo"
                            :data-vv-as="filtersLabel.riCo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6 v-if="this.filters.review === 'amend'">
                          <v-text-field
                            v-model="filters.insdName1"
                            :label="filtersLabel.insdName1"
                            :error-messages="errors.collect('insdName1')"
                            data-vv-name="insdName1"
                            :data-vv-as="filtersLabel.insdName"
                            v-validate="'entry'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6 v-else>
                          <v-text-field
                            v-model="filters.cesEndtCnt"
                            :label="filtersLabel.cesEndtCnt"
                            :error-messages="errors.collect('cesEndtCnt')"
                            data-vv-name="cesEndtCnt"
                            :data-vv-as="filtersLabel.cesEndtCnt"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <cal-picker
                            v-model="filters.comDate"
                            :label="filtersLabel.comDate"
                            :data-vv-as="filtersLabel.comDate"
                            data-vv-name="comDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <cal-picker
                            v-model="filters.expDate"
                            :label="filtersLabel.expDate"
                            :data-vv-as="filtersLabel.expDate"
                            data-vv-name="expDate"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 xs6>
                          <cal-picker
                            v-model="filters.tranDate"
                            :label="filtersLabel.tranDate"
                            :data-vv-as="filtersLabel.tranDate"
                            data-vv-name="tranDate"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                      <transition name="slide-x-transition" mode="out-in">
                        <v-layout row wrap v-if="showDetailFilters">
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-uppercase="filters.insdRefNo"
                              v-model="filters.insdRefNo"
                              :label="filtersLabel.insdRefNo"
                              :error-messages="errors.collect('insdRefNo')"
                              data-vv-name="insdRefNo"
                              :data-vv-as="filtersLabel.insdRefNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.billAcct1Ref"
                              :label="filtersLabel.billAcct1Ref"
                              :error-messages="errors.collect('billAcct1Ref')"
                              data-vv-name="billAcct1Ref"
                              :data-vv-as="filtersLabel.billAcct1Ref"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.cedPolNo"
                              :label="filtersLabel.cedPolNo"
                              :error-messages="errors.collect('cedPolNo')"
                              data-vv-name="cedPolNo"
                              :data-vv-as="filtersLabel.cedPolNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.cedCesNo"
                              :label="filtersLabel.cedCesNo"
                              :error-messages="errors.collect('cedCesNo')"
                              data-vv-name="cedCesNo"
                              :data-vv-as="filtersLabel.cedCesNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.riCo"
                              :label="filtersLabel.riCo"
                              :error-messages="errors.collect('riCo')"
                              data-vv-name="riCo"
                              :data-vv-as="filtersLabel.riCo"
                              v-validate="'entry|max:20'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.bkrSlipNo"
                              :label="filtersLabel.bkrSlipNo"
                              :error-messages="errors.collect('bkrSlipNo')"
                              data-vv-name="bkrSlipNo"
                              :data-vv-as="filtersLabel.bkrSlipNo"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.bkrTransRef"
                              :label="filtersLabel.bkrTransRef"
                              :error-messages="errors.collect('bkrTransRef')"
                              data-vv-name="bkrTransRef"
                              :data-vv-as="filtersLabel.bkrTransRef"
                              v-validate="'entry|max:60'"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </transition>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click.native="showDetailFilters = true" v-if="!showDetailFilters && checkAccess([permissionKeys.perm_0033])"
                      >Show More Filters</v-btn
                    >
                    <v-btn text @click.native="showDetailFilters = false" v-if="showDetailFilters && checkAccess([permissionKeys.perm_0033])"
                      >Show Less Filters</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-flex class="text-right">
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <div class="text-right mr-2">
                    <v-btn color="secondary" class="white--text" v-on="on">
                      <span>Columns</span>
                      <v-icon right dark>mdi-table-column-plus-after</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else>No column found</template>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-data-table
                  :headers="listHeaders"
                  :items="items"
                  :server-items-length="totalItems"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="pagination"
                  item-key="keyId"
                  :loading="loading"
                  :no-data-text="noDataText"
                  :custom-filter="customSearch"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action
                          :rowData="row"
                          :review="checkAccess([permissionKeys.perm_012035])"
                          @review="doReview(row.item)"
                          :query="checkAccess([permissionKeys.perm_012040])"
                          @query="doQuery(row.item)"
                          :loading="loading"
                        ></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="autocessionProcessing" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing RI AutoCession...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Oops something went wrong:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Common Search Filter - Start -->
      <v-dialog v-model="showFilterList" width="800px" persistent>
        <SearchFilter
          :boolRefresh="showFilterList"
          :filterTitle="'Saved Filters - Reinsurance Listing'"
          @close="showFilterList = false"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></SearchFilter>
      </v-dialog>

      <v-dialog v-model="saveFilter" width="800px" persistent>
        <UpdateSearchFilter
          :boolRefresh="saveFilter"
          :dialogTitle="'Filter'"
          :actionName="'new'"
          :filters="filters"
          @close="saveFilter = false"
          @reloadList="reloadList"
          :filterCode="filterCode"
          @applyDefaultFilter="applyDefaultFilter"
        ></UpdateSearchFilter>
      </v-dialog>
      <!-- Common Search Filter - End -->

      <warning v-model="promptWarning" @ok="performAmend"> {{ warningMsg }}</warning>
    </v-container>
  </page>
</template>

<script>
import clone from 'clone'
import { listMixin } from '@/mixins/listMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import { salutation, mainClass } from '@/const/claims'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import { permissionKeys } from '@/mixins/global/permissionKey'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      // Common Search Filter - Start
      permissionKeys: permissionKeys,
      filterCode: 'RIN',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      defaultFilter: {},
      // Common Search Filter - End
      listMode: 'Reinsurance',
      expanded: {},
      singleExpand: false,
      cardMenu: [
        { text: 'Reinsurance', icon: 'mdi-file', name: '', params: { tab: 'reinsurance' }, access: '', default: true },
        { text: 'Endorsement', icon: 'mdi-file-multiple', name: '', params: { tab: 'endorsement' }, access: '' }
      ],
      visibleTab: {},
      tab: undefined,
      filtersLabel: {
        polType: 'Main Classes',
        review: 'Review',
        polNo: 'Policy No.',
        mstPolOpenCvr: 'Open Cover / Master Policy No.',
        insdName1: 'Insured Name',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        tranDate: 'Transaction Date',
        insdRefNo: 'Insured Reference',
        billAcct1Ref: 'Billing Account No. 1',
        cedPolNo: 'Cedant Policy No.',
        cedCesNo: 'Cedant Cession No.',
        riCo: 'Reinsurer Reference',
        bkrSlipNo: 'Broker Slip No.',
        bkrTransRef: 'Broker Transaction Reference',
        cesEndtCnt: 'Cession Endorsement Count'
      },
      selectedColumns: ['polNo', 'insdName1', 'comDateDisp', 'expDateDisp', 'tranDateDisp', 'polType', 'co', 'stat', 'fac', 'tty', 'qs'],
      columns: [
        {
          text: 'Policy No.',
          align: 'left',
          sortable: false,
          value: 'polNo'
        },
        { text: 'Ren', value: 'renCnt' },
        { text: 'Endt', value: 'endtCnt' },
        { text: 'CesEndt', value: 'cesEndtCnt' },
        { text: 'Insured Name', value: 'insdName1' },
        { text: 'Pol Type', value: 'polType' },
        { text: 'RiCo', value: 'riCo' },
        { text: 'Com Date', value: 'comDateDisp' },
        { text: 'Exp Date', value: 'expDateDisp' },
        { text: 'Tran Date', value: 'tranDateDisp' },
        { text: 'Policy Stats', value: 'polStat' },
        { text: 'Tran Type', value: 'tranType' },
        { text: 'Rel', value: 'tranRel' },
        { text: 'Co', sortable: false, value: 'co' },
        { text: 'Stat', sortable: false, value: 'stat' },
        { text: 'Fac', sortable: false, value: 'fac' },
        { text: 'Tty', sortable: false, value: 'tty' },
        { text: 'QS', sortable: false, value: 'qs' },
        { text: 'Sfx', sortable: false, value: 'acctNoSfx' }
      ],
      params: {
        polType: [],
        review: [
          {
            label: 'true',
            value: true
          },
          {
            label: 'false',
            value: false
          }
        ],
        status: [],
        busCls: [],
        covers: []
      },
      filters: {
        review: undefined,
        polType: null,
        polNo: undefined,
        mstPolOpenCvr: undefined,
        insdName1: undefined,
        comDate: undefined,
        expDate: undefined,
        tranDate: undefined,
        comDateDisp: undefined,
        expDateDisp: undefined,
        tranDateDisp: undefined,
        insdRefNo: undefined,
        billAcct1Ref: undefined,
        cedPolNo: undefined,
        cedCesNo: undefined,
        riCo: null,
        bkrSlipNo: undefined,
        bkrTransRef: undefined
      },
      showDetailFilters: false,
      autocessionProcessing: false,
      loadingFlag: false,
      initialLoad: true,
      showErrorDialog: false,
      promptWarning: false,
      warningMsg: '',
      selectedRi: {},
      pagination: {
        sortDesc: [true],
        page: 1
      },
      isAfterDefFilter: false
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      if (this.isAfterDefFilter === true) {
        this.fetchData(false)
      }
    },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    listMode: function (value) {
      this.selectedColumns = []
      if (this.listMode === 'Amend RI') {
        this.selectedColumns = ['polNo', 'insdName1', 'comDateDisp', 'expDateDisp', 'tranDateDisp', 'polType', 'riCo', 'cesEndtCnt', 'acctNoSfx']
      } else {
        this.selectedColumns = ['polNo', 'insdName1', 'comDateDisp', 'expDateDisp', 'tranDateDisp', 'polType', 'co', 'stat', 'fac', 'tty', 'qs']
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    initRiOutInit() {
      return this.$store.state.reinsurance.riOutInit.init
    },
    riOutListing() {
      return this.$store.state.reinsurance.riOutListing
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    mainClsList() {
      let result = []
      Object.keys(mainClass).forEach(function (key) {
        const status = mainClass[key]
        if (key === 'NULL') {
          result.push({
            label: status,
            value: null
          })
        } else {
          result.push({
            label: status,
            value: key
          })
        }
      })
      return result
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  methods: {
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        this.visibleTab = { ...data }
        if (this.initialLoad === false) {
          this.doButtons(this.visibleTab.tab)
        }
      } else {
        this.visibleTab = {}
      }
    },
    doButtons(data) {
      this.filters.review = data
      if (data === 'reinsurance') {
        this.listMode = 'Reinsurance'
        this.fetchData(data)
      } else if (data === 'endorsement') {
        this.listMode = 'Endorsement'
        this.fetchData(data)
      } else if (data === 'amend') {
        this.listMode = 'Amend RI'
        this.fetchData(data)
      } else {
        this.listMode = 'Reinsurance'
        this.fetchData(false)
      }
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('riOutInit')])
      await this.$store.dispatch('riOutListingInit')
      await this.$store.dispatch('riAutoCessionInit')
      // Common Search Filter - Start
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      this.getDefaultFilter()
      // Common Search Filter - End
      this.cardMenu = []
      if (this.checkAccess([permissionKeys.perm_012005]) === true) {
        this.cardMenu.push({ text: 'Reinsurance', icon: 'mdi-file', name: '', params: { tab: 'reinsurance' }, access: '', default: true })
      }
      if (this.checkAccess([permissionKeys.perm_012010]) === true) {
        this.cardMenu.push({ text: 'Endorsement', icon: 'mdi-file-multiple', name: '', params: { tab: 'endorsement' }, access: '' })
      }
    },
    // Common Search Filter - Start
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.fetchData()
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.filters = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.fetchData(false)
    },
    async getDefaultFilter() {
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.filters = this.defaultFilter.filters
            }
            this.fetchData(false)
          } else {
            this.fetchData(false)
          }
          this.isAfterDefFilter = true
        } catch (err) {
          this.loading = false
        }
      }
    },
    // Common Search Filter - End
    doReview(data) {
      this.resetMessages()
      // AR: OS-660 Added to check if record is locked 2021-01-29
      let recKey = 'RI|' + data.polNo + '|' + data.renCnt + '|' + data.endtCnt
      this.checkRecordLock(recKey, 'RI').then((result) => {
        // Record not locked proceed to review 2021-01-29
        if (!result) {
          if (this.filters.review === 'amend') {
            this.selectedRi = data
            if (data.renPolNo === undefined) {
              this.performAmend()
            } else {
              this.promptWarning = true
              this.warningMsg = 'This policy has been renewed - do you want to proceed?'
            }
          } else {
            this.performReview(data)
          }
          // Record was locked show message 2021-01-29
        } else {
          this.loading = false
        }
      })
    },
    async performReview(data) {
      try {
        const dispatchObj = {
          polNo: data
        }
        this.loadingFlag = true
        this.$store.dispatch('loadReinsurance', dispatchObj).then(() => {
          this.$router.push({ name: 'riHeader', params: { mode: 'review', selectedRi: data, listMode: this.listMode } })
          this.loadingFlag = false
        })
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
      }
    },
    async performAmend() {
      try {
        const dispatchObj = {
          polNo: this.selectedRi
        }
        this.loadingFlag = true
        this.$store.dispatch('loadReinsurance', dispatchObj).then(() => {
          this.$router.push({ name: 'riOutAmend', params: { mode: 'review', selectedRi: this.selectedRi } })
          this.loadingFlag = false
        })
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
      }
    },
    async doQuery(data) {
      this.resetMessages()
      try {
        const dispatchObj = {
          polNo: data
        }
        this.loadingFlag = true
        if (this.filters.review === 'amend') {
          this.selectedRi = data
          this.$store.dispatch('loadReinsurance', dispatchObj).then(() => {
            this.$router.push({ name: 'riOutAmend', params: { mode: 'query', selectedRi: this.selectedRi } })
            this.loadingFlag = false
          })
        } else {
          this.$store.dispatch('loadReinsurance', dispatchObj).then(() => {
            this.$router.push({ name: 'riHeader', params: { mode: 'query', selectedRi: data } })
            this.loadingFlag = false
          })
        }
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
      }
    },
    async fetchData() {
      let apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          if (massageFilters.comDate) {
            massageFilters.comDate = formatDisplayDateTime2(removeTime(massageFilters.comDate))
          }
          if (massageFilters.expDate) {
            massageFilters.expDate = formatDisplayDateTime2(removeTime(massageFilters.expDate))
          }
          if (massageFilters.tranDate) {
            massageFilters.tranDate = formatDisplayDateTime2(removeTime(massageFilters.tranDate))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((riOut) => {
                const convertRiOut = {
                  keyId: riOut.keyId,
                  polNo: riOut.polNo,
                  renCnt: riOut.renCnt,
                  endtCnt: riOut.endtCnt,
                  cesEndtCnt: riOut.cesEndtCnt,
                  insdName1: riOut.insdName1,
                  polType: riOut.polTypeDesc,
                  comDate: riOut.comDate,
                  expDate: riOut.expDate,
                  tranDate: riOut.tranDate,
                  comDateDisp: this.formatDate(riOut.comDate),
                  expDateDisp: this.formatDate(riOut.expDate),
                  tranDateDisp: this.formatDate(riOut.tranDate),
                  polStat: riOut.polStat,
                  tranType: riOut.tranType,
                  tranRel: riOut.tranRel,
                  co: riOut.co,
                  stat: riOut.stat,
                  fac: riOut.fac,
                  tty: riOut.tty,
                  qs: riOut.qs,
                  acctNoSfx: riOut.acctNoSfx,
                  riCo: riOut.riCo,
                  riCoName: riOut.riCoName,
                  riType: riOut.riType,
                  renPolNo: riOut.renPolNo,
                  riComDate: riOut.riComDate,
                  riTranDate: riOut.riTranDate,
                  theirPolNo: riOut.theirPolNo,
                  ccaDate: riOut.ccaDate,
                  ccdDate: riOut.ccdDate,
                  polPd: riOut.polPd,
                  comm1: riOut.comm1,
                  comm2: riOut.comm2,
                  comm3: riOut.comm3,
                  disc: riOut.disc,
                  coInsPct: riOut.coInsPct,
                  billCurr: riOut.billCurr,
                  billCurrRate: riOut.billCurrRate,
                  dri: riOut.dri,
                  billCoIns: riOut.billCoIns,
                  appCoIns: riOut.appCoIns,
                  sfxDesc: riOut.sfxDesc
                }
                this.items.push(convertRiOut)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    closeWarningDialog() {
      this.promptWarning = false
    },
    doClearFilters() {
      this.filters.polType = null
      this.filters.polNo = null
      this.filters.renCnt = null
      this.filters.endtCnt = null
      this.filters.mstPolOpenCvr = null
      this.filters.insdName1 = null
      this.filters.comDate = null
      this.filters.expDate = null
      this.filters.tranDate = null
      this.filters.polStat = null
      this.filters.tranType = null
      this.filters.tranRel = null
      this.filters.insdRefNo = undefined
      this.filters.billAcct1Ref = undefined
      this.filters.cedPolNo = undefined
      this.filters.cedCesNo = undefined
      this.filters.bkrSlipNo = undefined
      this.filters.bkrTransRef = undefined
      this.filters.co = null
      this.filters.stat = null
      this.filters.fac = null
      this.filters.tty = null
      this.filters.qs = null
      this.filters.riCo = null
      this.defaultFilter = {}
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async performAutoCession() {
      const apiURI = this.$store.state.reinsurance.riAutoCession.menu.performAction
      if (apiURI) {
        try {
          this.autocessionProcessing = true
          const requestForm = {
            // Require input: PolNo, RenCnt, EndtCnt, PolScheme
            polNo: 'FIR18A00003200',
            renCnt: 0,
            endtCnt: 0,
            polScheme: 'HI01',
            actionName: 'FROM_POLICY_SUMMARY'
          }
          const result = await this.$http.post(apiURI, requestForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      this.autocessionProcessing = false
    }
  },
  created() {
    this.filters.review = 'reinsurance'
    // AR: OS-660 Added to check record lock 2021-01-21
    this.initCommonUtilMenu()
  },
  mixins: [listMixin, MessageMixin, recordLockMixin],
  components: {
    SearchFilter,
    UpdateSearchFilter
  }
}
</script>
